<template>
    <el-dialog
        :visible="visible"
        :modal-append-to-body="false"
        class="service-fee-statement-detail-dialog ah-detail-dialog"
        append-to-body
        :before-close="onBeforeClose"
        :lock-scroll="false"
        @open="onOpen"
    >
        <template slot="title">
            <div style="display: flex; justify-content: space-between; gap: 20px; margin-right: 45px; align-content: center">
                <div>
                    勞報單 <span class="sno"># {{ form.systemNo }}</span>
                </div>
                <el-dropdown @command="onMoreDropdownClick" placement="bottom">
                    <el-button class="dialog-more-button" size="mini" icon="el-icon-more"></el-button>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item command="exportPdf" icon="el-icon-printer"> 匯出 PDF</el-dropdown-item>
                        <el-dropdown-item v-if="!isQR()" command="copy" icon="el-icon-document-copy"> 複製勞報單</el-dropdown-item>
                        <el-dropdown-item v-if="!isQR()" command="edit" icon="el-icon-edit" :disabled="!isEditAvailable">
                            編輯 <span v-if="!isEditAvailable" style="font-size: 9pt">（已請款）</span></el-dropdown-item
                        >
                        <el-dropdown-item v-if="!isQR()" command="delete" icon="el-icon-delete" :disabled="!isEditAvailable">
                            刪除 <span v-if="!isEditAvailable" style="font-size: 9pt">（已請款）</span></el-dropdown-item
                        >
                    </el-dropdown-menu>
                </el-dropdown>
            </div>
        </template>
        <div class="dialog-section transparent">
            <el-row :gutter="40" style="padding: 10px 0 10px 0">
                <el-col :sm="9">
                    <table class="ah-basic-data-table" cellspacing="0" cellpadding="0">
                        <tr>
                            <th>狀態</th>
                            <td>
                                <StatusLabel :statusNum="form.status" />
                            </td>
                        </tr>
                        <tr>
                            <th style="">申請人</th>
                            <td>{{ form.crt_nam }}</td>
                        </tr>
                        <tr>
                            <th style="">申請日期</th>
                            <td>
                                {{ form.crtDat | dateFormater("YYYY-MM-dd") }}
                            </td>
                        </tr>
                    </table>
                </el-col>
                <el-col :sm="15">
                    <div v-if="form.audit" class="detail-row progress">
                        <ahServiceFeeStatementAuditProgress :data="form.audit.auditProgress" sort-flow :statusCode="form.audit.nowProcess" size="large" />
                    </div>
                </el-col>
            </el-row>
        </div>
        <div class="dialog-section">
            <div class="dialog-section-title">
                <span class="left-cell">勞務資訊</span>
            </div>
            <table class="ah-basic-data-table" cellspacing="0" cellpadding="0" style="margin-bottom: 15px">
                <tr>
                    <th>所屬專案</th>
                    <td>
                        {{ form.projectNam || "(無)" }}
                    </td>
                </tr>
                <tr>
                    <th style="padding: 8px 0">勞務摘要</th>
                    <td>
                        <div style="font-size: 15pt; font-weight: bold; padding: 10px 0">
                            {{ form.nam }}
                        </div>
                    </td>
                </tr>
                <tr>
                    <th>勞務內容</th>
                    <td style="white-space: pre-line">
                        {{ form.description || "--" }}
                    </td>
                </tr>
            </table>
        </div>

        <div class="dialog-section">
            <div class="dialog-section-title" style="display: flex; justify-content: space-between">
                <span> 付款資訊</span>
            </div>
            <el-row :gutter="40" style="padding: 10px 0 20px 0">
                <el-col :sm="12">
                    <!-- 編輯界面 -->
                    <el-form v-if="isDirectEditing" :model="directEditForm" :rules="directEditRules" ref="form" class="edit-form" label-position="right" label-width="150px" size="mini">
                        <el-form-item prop="incomeType" label="所得類別">
                            <el-select
                                v-model="directEditForm.incomeType"
                                filterable
                                placeholder="請選擇"
                                no-data-text="無資料"
                                no-match-text="無匹配資料"
                                size="small"
                                style="width: 100%"
                                @change="onChangeIncomeType"
                            >
                                <el-option v-for="item in serviceTypeList" :key="item.key" :label="item.label" :value="item.value" />
                            </el-select>
                        </el-form-item>
                        <el-form-item v-if="directEditForm.incomeType === 1 || directEditForm.incomeType === 2" prop="serviceType" label="業別代號">
                            <el-select v-model="directEditForm.serviceType" filterable placeholder="請選擇" no-data-text="無資料" no-match-text="無匹配資料" size="small" style="width: 100%">
                                <el-option v-for="item in serviceSubTypeList" :key="item.key" :label="`${item.key}：${item.label}`" :value="item.key" />
                            </el-select>
                        </el-form-item>
                        <el-form-item v-else-if="directEditForm.incomeType === 0" prop="otherServiceType" label="其他類型說明">
                            <el-input v-model="directEditForm.otherServiceType" :maxlength="50" :show-word-limit="true" size="small" style="width: 100%" />
                        </el-form-item>
                        <el-form-item prop="plannedPayDat " label="領款人預計支領日">
                            <el-date-picker v-model="directEditForm.plannedPayDat" type="date" value-format="timestamp" placeholder="選擇日期" size="small" style="width: 100%"></el-date-picker>
                        </el-form-item>
                        <el-form-item>
                            <div style="margin: 5px 0 15px">
                                <div v-if="form.status !== 3"><el-alert type="warning" :closable="false" style="line-height: 150%; margin-bottom: 12px">此編輯不會改變已轉送的請款單。</el-alert></div>
                                <el-button size="small" @click="onEndDirectEdit">取消</el-button>
                                <el-button size="small" type="primary" @click="onSubmitDirectEdit"> 儲存 </el-button>
                            </div>
                        </el-form-item>
                    </el-form>
                    <!-- 顯示界面 -->
                    <table v-else class="ah-basic-data-table" cellspacing="0" cellpadding="0">
                        <tr>
                            <th>所得類別</th>
                            <td>
                                <span>{{ getIncomeType(form.incomeType) }}</span>
                                <!-- <el-button v-if="isDirectEditAvailable && !isDirectEditing" size="mini" @click="onStartDirectEdit" style="margin-left: 10px">編輯</el-button> -->
                            </td>
                        </tr>
                        <tr v-if="form.incomeType === 1 || form.incomeType === 2">
                            <th>業別代號</th>
                            <td>{{ getServiceType(form.serviceType) }}</td>
                        </tr>
                        <tr v-else-if="form.incomeType === 0">
                            <th>其他類別說明</th>
                            <td>{{ form.otherServiceType }}</td>
                        </tr>
                        <tr>
                            <th>領款人預計支領日</th>
                            <td>{{ form.plannedPayDat | dateFormater("YYYY-MM-dd") }}</td>
                        </tr>
                        <tr>
                            <th style="white-space: nowrap;">領款人預計支領方式</th>
                            <td>{{ getServiceFeePlannedPayWayTxt(form.plannedPayWay) }}</td>
                        </tr>
                        <tr v-if="form.directEditSno">
                            <th style="color: #aaa; padding-top: 15px">最後編輯</th>
                            <td style="color: #aaa; padding-top: 15px">{{ form.directEditNam }} ({{ form.directEditDat | dateFormater("YYYY-MM-dd") }})</td>
                        </tr>
                    </table>
                </el-col>
                <el-col :sm="12">
                    <div class="info-amts">
                        <table class="ah-basic-data-table" cellspacing="0" cellpadding="0" style="width: 100%">
                            <tr>
                                <th class="cell-title">應付金額</th>
                                <td class="cell-amt"><Money :v="form.amt" style="font-size: 18pt" :precision="form.cny === 'TWD' ? null : 4" /></td>
                                <td class="cell-cny">
                                    <span class="cny" style="font-weight: bold">{{ form.cny }}</span>
                                </td>
                            </tr>
                            <tr v-if="form.cny !== 'TWD'">
                                <th class="cell-title">約定匯率</th>
                                <td class="cell-amt"><Money :v="form.cnyRat" :precision="4" /></td>
                                <td class="cell-cny"></td>
                            </tr>
                            <tr v-if="form.cny !== 'TWD'">
                                <th class="cell-title">應付金額（約當台幣）</th>
                                <td class="cell-amt"><Money :v="form.amt * form.cnyRat" round /></td>
                                <td class="cell-cny"><span class="cny">TWD</span></td>
                            </tr>
                            <tr>
                                <td colspan="3" style="text-align: right; padding-bottom: 15px"></td>
                            </tr>
                            <tr>
                                <th class="cell-title">
                                    <span class="calc-sign">−</span>
                                    <span>代扣所得稅款 {{ form.taxRatio }}%</span>
                                </th>
                                <td class="cell-amt"><Money :v="form.taxAmt" /></td>
                                <td class="cell-cny"><span class="cny">TWD</span></td>
                            </tr>
                            <tr>
                                <th class="cell-title">
                                    <span class="calc-sign">−</span>
                                    <span>代扣二代健保 {{ form.gen2Ratio }}%</span>
                                </th>
                                <td class="cell-amt"><Money :v="form.gen2Amt" /></td>
                                <td class="cell-cny"><span class="cny">TWD</span></td>
                            </tr>
                            <tr>
                                <th class="cell-title">
                                    <span class="calc-sign">＝</span>
                                    <span>實付金額</span>
                                    <span v-if="form.cny !== 'TWD'">（約當台幣）</span>
                                </th>
                                <td class="cell-amt"><Money :v="form.realPayAmt" /></td>
                                <td class="cell-cny"><span class="cny">TWD</span></td>
                            </tr>
                            <tr v-if="form.cny !== 'TWD'">
                                <th class="cell-title">
                                    <span class="calc-sign">＝</span>
                                    <span>實付金額（原幣別）</span>
                                </th>
                                <td class="cell-amt"><Money :v="realPayAmtInOriginalCny" :precision="form.cny === 'TWD' ? null : 4" /></td>
                                <td class="cell-cny">
                                    <span class="cny">{{ form.cny }}</span>
                                </td>
                            </tr>
                        </table>
                    </div>
                </el-col>
            </el-row>
        </div>

        <div class="dialog-section">
            <div class="dialog-section-title">領款資訊</div>
            <el-row v-if="form.personalOutsourcingSno && form.personalOutsourcingSno !== -1" :gutter="40" style="padding: 10px 0 20px 0">
                <el-col :sm="12">
                    <table class="ah-basic-data-table" cellspacing="0" cellpadding="0">
                        <tr>
                            <th>領款人</th>
                            <td>{{ form.payee || "--" }}</td>
                        </tr>
                        <tr>
                            <th>國籍</th>
                            <td>{{ getNationalityTxt(form.nationality) }}</td>
                        </tr>
                        <tr>
                            <th>{{ getBsnLabelTxt(form.idTyp) }}</th>
                            <td>{{ form.bsn || "--" }}</td>
                        </tr>
                        <tr>
                            <th>聯絡電話</th>
                            <td>{{ form.phone || "--" }}</td>
                        </tr>
                        <tr>
                            <th>E-mail</th>
                            <td>{{ form.email || "--" }}</td>
                        </tr>
                        <tr>
                            <th>戶籍地址</th>
                            <td>{{ getPermanentAddrTxt() }}</td>
                        </tr>
                        <tr>
                            <th>聯絡地址</th>
                            <td>{{ getContactAddrTxt() }}</td>
                        </tr>
                        <tr>
                            <th>投保工會</th>
                            <td>{{ form.hasUnionInsurance ? "是" : "否" }}</td>
                        </tr>
                        <tr v-if="form.hasUnionInsurance">
                            <th>投保工會有效日期</th>
                            <td>{{ form.unionInsuranceExpireDate | dateFormater("YYYY-MM-dd") }}</td>
                        </tr>
                    </table>
                </el-col>
                <el-col :sm="12">
                    <div class="info-amts">
                        <table v-if="form.plannedPayWay === 2" class="ah-basic-data-table" cellspacing="0" cellpadding="0" style="width: 100%">
                            <tr>
                                <th>收款銀行 <span v-if="form.accountType === 2">(外國)</span></th>
                                <td>
                                    <div v-if="form.accountType === 1">
                                        <div>{{ form.bankName }} ({{ form.bnkBoo }})</div>
                                        <div v-if="form.bnkDoo">分行代碼：{{ form.bnkDoo }}</div>
                                    </div>
                                    <div v-if="form.accountType === 2">
                                        <div>{{ form.abroadBankName }}</div>
                                    </div>
                                </td>
                            </tr>
                            <tr v-if="form.accountType === 2">
                                <th>Swift Code</th>
                                <td>{{ form.swiftCode }}</td>
                            </tr>
                            <tr>
                                <th>收款戶名</th>
                                <td>{{ form.bnkNam }}</td>
                            </tr>
                            <tr>
                                <th>收款帳號</th>
                                <td>{{ form.bnkAcc }}</td>
                            </tr>
                            <tr>
                                <th>帳戶備註</th>
                                <td>{{ form.bnkNote }}</td>
                            </tr>
                            <tr v-if="form.passbookDoc">
                                <th>帳戶存摺封面</th>
                                <td>
                                    <el-image class="image-rect" style="width: 130px; height: 80px" :src="form.passbookDoc" :previewSrcList="[form.passbookDoc]" fit="contain" />
                                </td>
                            </tr>
                        </table>
                    </div>
                </el-col>
            </el-row>
            <div v-else>
                <div>(領款人資訊未填寫)</div>
            </div>
        </div>

        <div class="dialog-section">
            <div class="dialog-section-title">
                <span class="left-cell">
                    <span>檢附文件</span>
                    <span v-if="form.toBeAddFile" class="toBeAddFile-tag">待補證件</span>
                </span>
            </div>
            <table class="ah-basic-data-table" cellspacing="0" cellpadding="0">
                <tr v-if="form.idCardFront || form.idCardBack">
                    <th>證件正/反</th>
                    <td>
                        <el-image v-if="form.idCardFront" class="image-rect id" :src="form.idCardFront" :previewSrcList="[form.idCardFront]" fit="contain" />
                        <el-image v-if="form.idCardBack" class="image-rect id" :src="form.idCardBack" :previewSrcList="[form.idCardBack]" fit="contain" />
                    </td>
                </tr>
                <tr v-if="form.unionInsuranceDoc">
                    <th>投保工會證明</th>
                    <td>
                        <el-image class="image-rect" style="width: 240px; height: 130px" :src="form.unionInsuranceDoc" :previewSrcList="[form.unionInsuranceDoc]" fit="contain" />
                    </td>
                </tr>
            </table>
        </div>

        <div class="dialog-section paid" v-if="form.status === 4 || form.status === 5 || form.status === 6 || form.status === 7">
            <div class="dialog-section-title">
                <span class="left-cell">轉送請款單</span>
            </div>
            <table class="ah-basic-data-table" cellspacing="0" cellpadding="0">
                <tr>
                    <th>請款單單號</th>
                    <td>
                        <el-button type="text" v-if="form.paymentSno" @click="openPayment(form.paymentSno)" style="padding: 0">
                            {{ form.payoo }}
                        </el-button>
                        <PaymentStatusLabel v-if="form.status === 7" :statusNum="4" />
                    </td>
                </tr>
                <tr v-if="form.paymentSno">
                    <th>實際付款日</th>
                    <td>
                        <div v-if="form.paymentSno && form.pay_dat">{{ form.pay_dat | dateFormater("YYYY-MM-dd") }}</div>
                        <div v-else>---</div>
                    </td>
                </tr>
                <tr v-if="form.paymentSno">
                    <th>實際付款方式</th>
                    <td>
                        <div v-if="form.paymentSno && form.pay_dat">{{ getPaymentPayWayTxt(form.payWay) }}</div>
                        <div v-else>---</div>
                    </td>
                </tr>
            </table>
        </div>

        <!-- Footer 功能按鈕 -->
        <div v-if="form.sno && isShowActions" class="detail-row footer">
            <div style="display: flex; justify-content: space-between">
                <div style="display: flex">
                    <el-button type="" @click="onBeforeClose" icon="el-icon-close"> 返回列表 </el-button>
                    <el-button @click="onExportPdf" icon="el-icon-printer"> 匯出 PDF</el-button>
                </div>
                <div>
                    <el-tooltip v-if="!isQR()" placement="top" :manual="isDeleteAvailable">
                        <template slot="content">
                            <span v-if="!isStatusWaitingToPay">已請款無法刪除，請先作廢請款單 {{ form.payoo }}</span>
                            <span v-else-if="!isDeleteAvailable">非建立者或無刪除權限</span>
                        </template>
                        <el-button :type="isDeleteAvailable ? 'danger' : 'normal'" :disabled="!isDeleteAvailable" @click="onDelete" icon="el-icon-delete"> 刪除 </el-button>
                    </el-tooltip>
                    <el-tooltip v-if="!isQR()" placement="top" :manual="isEditAvailable">
                        <template slot="content">
                            <span v-if="!isStatusWaitingToPay">已請款無法編輯，如需編輯請先作廢請款單 {{ form.payoo }}</span>
                            <span v-else-if="!isDeleteAvailable">非建立者或無編輯權限</span>
                        </template>
                        <el-button :disabled="!isEditAvailable" @click="onEdit" icon="el-icon-edit"> 編輯 </el-button>
                    </el-tooltip>
                    <template v-if="isStatusWaitingToPay && !isQR()">
                        <template v-if="!isAuth('A01')">
                            <el-tooltip placement="top" content="無「申請請款單」權限">
                                <el-button type="primary" disabled icon="el-icon-right">轉送請款單</el-button>
                            </el-tooltip>
                        </template>
                        <template v-else-if="!form.personalOutsourcingSno || form.personalOutsourcingSno === -1">
                            <el-tooltip placement="top" content="「領款人資訊」未填寫，無法轉送請款單。">
                                <el-button type="primary" disabled icon="el-icon-right">轉送請款單</el-button>
                            </el-tooltip>
                        </template>
                        <template v-else-if="form.toBeAddFile">
                            <el-tooltip placement="top" content="此單標示為「待補證件」無法轉送請款單。">
                                <el-button type="primary" disabled icon="el-icon-right">轉送請款單</el-button>
                            </el-tooltip>
                        </template>
                        <el-button v-else type="primary" @click="onTransform" icon="el-icon-right"> 轉送請款單 </el-button>
                    </template>
                    <!-- <el-button v-if="form.status === 7" type="primary" @click="onEditTransform" icon="el-icon-right"> 編輯轉送請款單 </el-button> -->
                </div>
            </div>
        </div>
        <PaymentDetailDialog :visible="paymentDetailDialog.visible" :sno="paymentDetailDialog.sno" @close="onDetailDialogClose" />
        <ExportPdfDialog ref="exportPdfDialog" :visible="exportPdfDialog.visible" @close="OnExportPdfDialogClose" />
    </el-dialog>
</template>

<script>
import _ from 'lodash';
import {
    serviceFeeStatementType, serviceTypeList, serviceType9AList, serviceType9BList, nationalityList, serviceFeePlannedPayWay, paymentPayWay, bankAccountType,
} from '@/assets/commonData/options';
import ahServiceFeeStatementAuditProgress from '@/components/ui/ahServiceFeeStatementAuditProgress.vue';
import StatusLabel from '@/components/dashboard/ServiceFeeStatement/StatusLabel.vue';
import PaymentStatusLabel from '@/components/dashboard/Payment/PaymentStatusLabel.vue';

export default {
    name: 'ServiceFeeStatementDetailDialog',
    components: {
        ahServiceFeeStatementAuditProgress,
        StatusLabel,
        PaymentStatusLabel,
        PaymentDetailDialog: () => import('@/components/dashboard/Payment/PaymentDetailDialog.vue'),
        ExportPdfDialog: () => import('@/components/dashboard/ServiceFeeStatement/ExportPdf/ExportPdfDialog.vue'),
    },
    props: {
        visible: Boolean,
        sno: Number,
        isShowActions: {
            type: Boolean,
            default: true,
        },
    },
    computed: {
        isStatusWaitingToPay() {
            return this.form.status === 3;
        },
        isEditAvailable() {
            return this.isStatusWaitingToPay && (this.isAuth('H02') || this.isCreator);
        },
        isDeleteAvailable() {
            return this.isStatusWaitingToPay && (this.isAuth('H02') || this.isCreator);
        },
        isTransformAvailable() {
            if (!this.isAuth('A01')) return false;
            if (!(this.isAuth('H02') || this.isCreator)) return false;

            return true;
        },

        realPayAmtInOriginalCny() {
            if (this.form) {
                const realPayAmtInOriginCny = (Math.round(this.form.amt * this.form.cnyRat) - this.form.taxAmt - this.form.gen2Amt) / this.form.cnyRat;
                return Math.round(realPayAmtInOriginCny * 100) / 100;
            }
            return '';
        },
        serviceSubTypeList() {
            switch (this.directEditForm.incomeType) {
            case 1:
                return serviceType9AList;
            case 2:
                return serviceType9BList;
            default:
                return [];
            }
        },
        isDirectEditAvailable() {
            // 有勞報單總管理(H02)的都可以編輯
            if (this.isAuth('H02')) return this.form.status === 3;

            // 或者為申請人才可編輯自己的勞報單
            if (this.isCreator) return this.form.status === 3;

            return false;
        },
        isCreator() {
            return this.form.crtSno === this.$store.getters['account/userSno'];
        },
        isPM() {
            return this.form.projectSTF_SNO === this.$store.getters['account/userSno'];
        },
        isPA() {
            return this.form.projectAuditor === this.$store.getters['account/userSno'];
        },
    },
    data() {
        return {
            isLoading: false,
            form: {},
            directEditForm: {
                incomeType: null,
                serviceType: null,
                plannedPayDat: null,
                plannedPayWay: null,
                otherServiceType: null,
            },
            directEditRules: {
                incomeType: [{ required: true, message: '請選擇所得類別', trigger: 'change' }],
                serviceType: [{ required: true, message: '請選擇業務類別', trigger: 'change' }],
                plannedPayDat: [{ required: true, message: '請選擇預計付款日', trigger: 'change' }],
                plannedPayWay: [{ required: true, message: '請選擇預計支領方式', trigger: 'change' }],
                otherServiceType: [{ required: true, message: '請輸入其他業務說明', trigger: 'change' }],
            },
            paymentDetailDialog: {
                visible: false,
                sno: null,
            },
            exportPdfDialog: {
                visible: false,
            },

            isDirectEditing: false,
            serviceTypeList,
            isEdited: false,
        };
    },
    methods: {
        async onOpen() {
            try {
                const resp = await this.$api({
                    url: 'ServiceOrder/GetServiceFeeStatement',
                    method: 'GET',
                    params: { sno: this.sno },
                });

                this.form = resp.data.item;

                this.directEditForm.incomeType = this.form.incomeType;
                this.directEditForm.serviceType = this.form.serviceType;
                this.directEditForm.plannedPayDat = this.form.plannedPayDat;
                this.directEditForm.plannedPayWay = this.form.plannedPayWay;
                console.log(resp.data.item);
            } catch (e) {
                console.log(e);
            }
        },
        async onDelete() {
            try {
                await this.$confirm('確定要刪除此勞報單？', {
                    confirmButtonText: '確定',
                    cancelButtonText: '取消',
                });

                await this.$api({
                    url: 'ServiceOrder/DeleteServiceFeeStatement',
                    method: 'DELETE',
                    data: { sno: this.sno },
                });
                this.$emit('close', true);
            } catch (e) {
                console.log(e);
            }
        },
        onEdit() {
            this.$router.push({ name: 'edit-service-fee-statement', params: { sno: this.sno } });
        },

        // 關閉視窗
        onBeforeClose() {
            this.$emit('close', this.isEdited);

            this.isDirectEditing = false;
            this.isEdited = false;
        },

        getServiceFeeStatementType(value) {
            return _.find(serviceFeeStatementType, ['key', value])?.value;
        },
        getIncomeType(value) {
            return _.find(serviceTypeList, ['value', value])?.label;
        },
        getServiceType(value) {
            const found = _.find([...serviceType9AList, ...serviceType9BList], ['key', value]);
            return found ? `${found.key}：${found.label}` : '';
        },
        getNationalityTxt(value) {
            return _.find(nationalityList, ['key', value])?.label;
        },
        getServiceFeePlannedPayWayTxt(value) {
            return _.find(serviceFeePlannedPayWay, ['key', value])?.label;
        },
        getPaymentPayWayTxt(value) {
            return _.find(paymentPayWay, ['key', value])?.label;
        },
        getAccountTypeTxt(value) {
            return _.find(bankAccountType, ['key', value])?.label;
        },
        getBsnLabelTxt(idTyp) {
            switch (idTyp) {
            case 0:
                return '身分證號碼';
            case 3:
                return '營業統一編號';
            case 1:
                return '護照號碼';
            case 2:
                return '居留證';
            default:
                return '---';
            }
        },
        getPermanentAddrTxt() {
            if (this.form && this.form.nationality === 0) {
                return `${this.form.permanentAdR_CODE || ''} ${this.form.permanentAddrCty}${this.form.permanentAddr}`;
            }
            if (this.form && (this.form.nationality === 1 || this.form.nationality === 2)) {
                return `${this.form.permanentAddr}, ${this.form.permanentAddrAra} ${this.form.permanentAdR_CODE}`;
            }
            return '---';
        },
        getContactAddrTxt() {
            if (this.form && this.form.nationality === 0) {
                return `${this.form.adR_CODE || ''} ${this.form.contactAddrCty}${this.form.contactAddr}`;
            }
            if (this.form && (this.form.nationality === 1 || this.form.nationality === 2)) {
                return `${this.form.contactAddr}, ${this.form.contactAddrAra} ${this.form.adR_CODE}`;
            }
            return '---';
        },
        openPayment(sno) {
            this.paymentDetailDialog.visible = true;
            this.paymentDetailDialog.sno = sno;
        },
        onDetailDialogClose(refresh) {
            this.paymentDetailDialog.visible = false;
            this.paymentDetailDialog.sno = null;

            if (refresh) {
                this.isEdited = true;
                this.onOpen();
            }
        },
        onMoreDropdownClick(command) {
            switch (command) {
            case 'copy':
                this.onCopy();
                break;
            case 'exportPdf':
                this.onExportPdf();
                break;
            case 'edit':
                this.onEdit();
                break;
            case 'delete':
                this.onDelete();
                break;
            default:
            }
        },
        onCopy() {
            this.$router.push({ name: 'add-service-fee-statement', query: { copyFrom: this.form.sno } });
        },
        onExportPdf() {
            this.$refs.exportPdfDialog.setSnoList([this.form.sno]);
            this.exportPdfDialog.visible = true;
        },
        OnExportPdfDialogClose() {
            this.exportPdfDialog.visible = false;
        },
        onTransform() {
            this.$router.push({ name: 'transform-service-fee-statement', query: { list: this.form.sno } });
        },
        onEditTransform() {
            this.$router.push({
                name: 'edit-transform-service-fee-statement',
                params: { sno: this.form.paymentSno },
                query: { from: 'payment' },
            });
        },
        onChangeIncomeType() {
            this.directEditForm.serviceType = null;
            this.directEditForm.otherServiceType = null;

            this.$nextTick(() => {
                this.$refs.form.clearValidate();
            });
        },
        onStartDirectEdit() {
            this.isDirectEditing = true;
        },
        onEndDirectEdit() {
            this.isDirectEditing = false;
        },
        onSubmitDirectEdit() {
            this.$refs.form.validate(async (valid) => {
                if (valid) {
                    try {
                        this.isLoading = true;
                        await this.$api({
                            url: 'ServiceOrder/DirectUpdateServiceFeeStatement',
                            method: 'POST',
                            data: { sno: this.form.sno, ...this.directEditForm },
                        });
                        this.isDirectEditing = false;
                        this.isEdited = true;
                        this.onOpen();
                    } catch (e) {
                        console.log(e);
                    } finally {
                        this.isLoading = false;
                    }
                }
            });
        },
    },
};
</script>
<style lang="scss">
@import "@/assets/scss/vars.scss";
.service-fee-statement-detail-dialog .edit-form {
    flex: 1;
    display: flex;
    align-items: center;
    flex-direction: column;
    > * {
        width: 100%;
    }
}
.service-fee-statement-detail-dialog.ah-detail-dialog {
    @media print {
        position: relative;
    }

    .dialog-more-button {
        background-color: #ffffff3a;
        border: 0;
        color: #fff;
        padding: 9px 15px;
        border-radius: 8px;

        &:hover {
            background-color: #ffffff5c;
        }
    }

    .el-dialog {
        margin-top: 6vh;
        background-color: #f6f6f6;
        max-width: 900px;
    }

    .nam-edit-input {
        font-size: 14pt;
        font-weight: 900;

        .el-input__inner {
            height: 40px;
            line-height: 40px;
        }
    }

    .info-amts {
        margin-right: 0;

        @media (min-width: 992px) {
            margin-right: 25px;
        }

        .cell-title,
        .cell-cny {
            white-space: nowrap;
            word-break: keep-all;
        }
    }

    .cny {
        font-size: 9pt;
        opacity: 0.7;
        margin: 0 0 0 10px;
    }

    .payment-type {
        display: inline-block;

        .type-label {
            color: $main-color;
            font-weight: bold;
        }

        &.project {
            // border: 1px solid #e8e8e8;

            .type-label {
                border-top-right-radius: 0;
                border-bottom-right-radius: 0;
            }
        }

        .project-label {
            display: inline-block;
            padding: 0px 10px;
            line-height: 30px;
            color: #555;
            font-size: 10pt;
            vertical-align: top;
            border-top-right-radius: 6px;
            border-bottom-right-radius: 6px;

            .type {
                display: inline-block;
                color: #666;
                background-color: #eee;
                margin-right: 8px;
                line-height: 20px;
                padding: 0 8px;
                font-size: 9pt;
                border-radius: 8px;
            }

            .sn {
                display: none;
            }

            .name {
                &.clickable {
                    cursor: pointer;

                    &:hover {
                        color: $main-color;
                    }
                }
            }
        }
    }

    .dialog-section {
        // border-top: 1px solid #eee;
        padding: 20px 30px;
        background-color: #fff;
        margin: 10px 10px;
        border-radius: 6px;
        border-left: 4px solid transparent;

        &.transparent {
            background-color: transparent;
        }

        @media (max-width: 720px) {
            padding: 20px 13px;
        }

        > .dialog-section-title {
            display: table;
            width: 100%;
            margin: 0px 0 20px 0;
            font-size: 12pt;
            font-weight: 600;
            color: $main-color;

            > .left-cell {
                display: table-cell;
                vertical-align: top;
            }

            > .right-cell {
                display: table-cell;
                vertical-align: top;
                text-align: right;
            }
        }

        &.paid {
            background-color: #fffdf6;
            border-color: #f18d13;

            .dialog-section-title {
                color: #f18d13;

                .edit-btn {
                    color: #f18d13;
                }
            }
        }

        &.checked {
            background-color: #f7fff3;
            border-color: #0baa1b;

            .dialog-section-title {
                color: #0baa1b;
            }
        }

        &.reject {
            border-color: red;
            background-color: #fff7f7;

            .dialog-section-title {
                color: red;
            }
        }

        &.cancel {
            background-color: #e4e4e4;

            .dialog-section-title {
                color: #666;
            }
        }

        .edit-btn {
            margin-left: 10px;
            padding: 5px 10px;

            &.orange {
                border-color: #f18d1366;

                &:hover {
                    background-color: #f18d13;
                    color: #fff;
                }
            }
        }
    }

    .detail-row.footer {
        border-top: 0;
        background-color: unset;
    }

    .date-warning {
        font-size: 9pt;
        color: rgb(255, 119, 0);
    }

    .nam-block {
        display: flex;
        justify-content: space-between;
    }
    .pay-way-change-hint {
        font-size: 9pt;
        color: rgb(130, 130, 130);
    }

    .cell-amt {
        text-align: right;
    }
    .cell-cny {
        width: 40px;
        text-align: right;
    }
    .image-rect {
        border: 2px solid #e5e5e5;
        border-radius: 6px;
        margin: 5px;
        transition: border-color 0.2s;

        &:hover {
            border: 2px solid #ccc;
        }

        &.id {
            width: 240px;
            height: 130px;
        }
    }
    .calc-sign {
        display: inline-block;
        width: 18px;
        height: 20px;
        line-height: 20px;
        text-align: center;
        margin-right: 5px;
        // background-color: #eee;
        border-radius: 3px;
        opacity: 0.5;
    }
    .el-alert__description {
        margin-top: 0;
    }

    .toBeAddFile-tag {
        display: inline-block;
        padding: 0 10px;
        border-radius: 4px;
        margin-left: 15px;
        background-color: $main-color;
        color: #fff;
        font-weight: bold;
        font-size: 9.5pt;
        line-height: 25px;
        height: 25px;
    }
}
</style>

<style lang="scss" scoped>
</style>
